/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchPaymentMethods } from '../../../actions/ClientData';

const mapOptionToDisplay = option =>
    option.provider == 'banktransfer'
        ? {
              title: 'Pay by bank transfer on invoice',
              shortTitle: 'bank transfer',
              info: '',
          }
        : option.add_payment_option
        ? {
              title: option.add_payment_option,
              shortTitle: 'method',
              info: '',
          }
        : {
              title: '',
              shortTitle: '',
              info: '',
          };

class RemoveMethod extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    onSubmit = () => {
        this.setState({ isLoading: true });
        this.props
            .handleSubmit()
            .then(() => {
                this.props.fetchPaymentMethods(this.props.basicInfo.id, 'OK');
                this.props.onDismiss();
            })
            .catch(err => {
                this.setState({ isLoading: false });
                const message =
                    err &&
                    err.response &&
                    err.response.data &&
                    err.response.data.meta
                        ? err.response.data.meta.detail
                        : err.message;
                this.props.handleError(message);
            });
    };

    render() {
        const displayOption = mapOptionToDisplay(this.props.paymentMethod);
        return (
            <div className="remove-method-modal">
                <div className="payment-summary">
                    <div>{displayOption.title}</div>
                    <div>{displayOption.info}</div>
                </div>
                <div className="payment-instruction">
                    <div className="description">
                        {this.props.paymentMethod.is_default ? (
                            <p>
                                Your next valid payment method will become your
                                new default and will be used to settle any
                                pending jobs.
                            </p>
                        ) : (
                            <p>
                                By removing this payment method any pending jobs
                                will be settled with your default payment
                                method.
                            </p>
                        )}
                    </div>
                </div>
                <div className="modal-bottom-bar">
                    <button
                        className="table-action-button table-action-button-danger"
                        onClick={this.onSubmit}
                        disabled={this.state.isLoading}
                    >
                        Proceed
                    </button>
                    <button
                        className="table-action-button table-action-button-secondary"
                        onClick={this.props.onDismiss}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    basicInfo: state.clientData.basicInfo,
});

export default connect(mapStateToProps, { fetchPaymentMethods })(RemoveMethod);
